import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './index.css';
import App from './App';

// Suppress noisy AbortError from fetch cancellations (e.g., effect cleanup in StrictMode)
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event?.reason;
      const name = reason?.name || '';
      const msg = reason?.message || String(reason || '');
      if (name === 'AbortError' || /signal is aborted/i.test(msg) || /aborted/i.test(msg) || msg === 'unmount' || msg === 'refresh') {
        event.preventDefault();
      }
    } catch (_) {}
  });

  // Also suppress window 'error' events specifically for AbortError thrown by some fetch polyfills
  window.addEventListener('error', (event) => {
    try {
      const err = event?.error;
      const name = err?.name || '';
      const msg = err?.message || '';
      if (name === 'AbortError' || /signal is aborted/i.test(msg) || /aborted/i.test(msg)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    } catch (_) {}
  }, true); // Use capture phase to run before React Dev Overlay
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ScrollToTop />
    <App />
  </Router>
);
